/* eslint-disable no-empty */
import React, { useState, useEffect, useRef } from 'react';
// import styled from 'styled-components';
import { Input, Icon } from 'rsuite';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Textarea,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/react';
import { FocusScope } from '@react-aria/focus';
import { ModalWrapper } from '../styles/ModalWrapper';
import * as Constants from '../../../constants';
import { showNotification } from '../../notification';
import { ResponseModalFooter } from './ResponseModalFooter';
import {
  useSubmitResponse,
  useCurrentUser,
  useUserPromptResponses,
} from '../../../api';

export const TextResponse: React.FC<{
  promptId: string;
  show: boolean;
  questionText: string;
  setShowTextResponseModal: (show: boolean) => void;
}> = ({ promptId, show, setShowTextResponseModal, questionText }) => {
  const { data: user } = useCurrentUser();

  const {
    data: responses,
    isLoading: myResponsesLoading,
  } = useUserPromptResponses(promptId, user?.id || '');

  const myResponse = responses && responses[Constants.RESPONSE_TYPE_IDS.TEXT];

  const {
    mutateAsync: submitResponse,
    isLoading,
    isError,
    error: submitErrorMessage,
  } = useSubmitResponse(promptId);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = useRef<HTMLTextAreaElement>(null);

  // const [modalOpen, setModalOpen] = useState(false);

  const [responseText, setResponseText] = useState(
    (myResponse && myResponse.text) || ''
  );

  const handleInputText = (text: string) => {
    setResponseText(text);
  };

  const handleClose = () => {
    setShowTextResponseModal(false);
    onClose();
  };

  useEffect(() => {
    if (show && !!myResponse) {
      setResponseText(myResponse?.text || '');
    }
    return show ? onOpen() : handleClose();
  }, [show, JSON.stringify(myResponse)]);

  if (!user || myResponsesLoading) return null;

  const handleSubmitResponse = async () => {
    try {
      const result = await submitResponse({
        prompt_id: promptId,
        response_type: Constants.RESPONSE_TYPE_IDS.TEXT,
        text: responseText,
      });
      showNotification({
        type: 'success',
        title: 'Success!',
        message: 'Your response was submitted successfully!',
      });
      setShowTextResponseModal(false);
    } catch (e) {}
  };

  const { message: errorMessage = '' } = (submitErrorMessage as any) || {};
  const strippedText = questionText.replace(/<[^>]+>/g, '');

  return (
    <Modal
      initialFocusRef={initialRef}
      size="2xl"
      isOpen={isOpen}
      onClose={handleClose}
    >
      <ModalOverlay />
      <ModalWrapper>
        <ModalContent className="text-response">
          <ModalHeader>
            <Icon icon="commenting" /> Respond with text
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl isInvalid={isError}>
              <FormLabel>
                <div
                  className="question-text"
                  dangerouslySetInnerHTML={{ __html: strippedText }}
                />
              </FormLabel>
              <Textarea
                ref={initialRef}
                placeholder="Enter response here..."
                size="md"
                onChange={(e) => handleInputText(e.target.value)}
                onFocus={(e) =>
                  e.currentTarget.setSelectionRange(
                    e.currentTarget.value.length,
                    e.currentTarget.value.length
                  )
                }
                value={responseText}
              />
              <FormErrorMessage>{`${errorMessage}`}</FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ResponseModalFooter
            myResponse={myResponse}
            onDelete={() => null}
            handleClose={handleClose}
            isLoading={isLoading}
            isDisabled={!responseText.length}
            onSubmit={handleSubmitResponse}
          />
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};

// <IonModal
//     onDidDismiss={(e) => setShowTextResponseModal(false)}
//     isOpen={modalOpen}
//     cssClass="my-custom-class"
// >
//     <p>This is modal content</p>
//     <IonButton onClick={() => setShowTextResponseModal(false)}>
//         Close Modal
//     </IonButton>
// </IonModal>
